import { render } from "./processConfig.vue?vue&type=template&id=0827f0ea&scoped=true"
import script from "./processConfig.vue?vue&type=script&lang=js"
export * from "./processConfig.vue?vue&type=script&lang=js"

import "./processConfig.vue?vue&type=style&index=0&id=0827f0ea&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-0827f0ea"

export default script